import React, { PropsWithChildren } from 'react';
import styles from './typography.module.scss';

export const HeaderText: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<h2 className={styles.Header}>{children}</h2>
	);
};
